import React from "react";

const BookingsPlan =(props)=> {
    return(
        <>
        <div className="singapore-booking-package" style={{backgroundImage:`url(${props.DestinationImage})`}}>
        <h3 className="booking-nights">{props.Nights}</h3>
        <h6 className="booking-destinations" style={{height:'6vh'}}>{props.Destination}</h6>
        <button>Book Now</button>
        </div>
        </>
    );
}

export default BookingsPlan ;